<ng-container *ngIf="data.type == 'basic'">
  <div class="adc-border adc-rounded adc-d-flex adc-flex-column adc-align-items-center adc-border-bottom adc-mb25">
    <div class="adc-p25 adc-pt45" style="height: 200px">
      <div class="adc-aucmpt" [ngClass]="[inputStyle ? inputStyle : '', data?.customClass ? data.customClass : '']">
        <!-- <mat-icon *ngIf="showIcon" (click)="clearSearch()">close</mat-icon> -->
        <span class="material-symbols-outlined" *ngIf="showIcon" (click)="clearSearch()">close</span>
        <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15px" *ngIf="showIcon" (click)="clearSearch()"><title>close</title><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg> -->
        <input type="text" id="{{data.id}}" (input)="onInputChange($event)" placeholder="{{data.placeHolder}}" [(ngModel)] = "searchInput" autocomplete="off">
        <ul class="adc-list" id="suggestions" *ngIf="showList && suggestions.length > 0">
          <li class="adc-list-item" *ngFor="let suggestion of suggestions" (click)="onSuggestionClick(suggestion)">{{ suggestion }}</li>
        </ul>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="data.type == 'tag'">
  <!-- <div class="adc-aucmpt" [ngClass]="[inputStyle ? inputStyle : '', data?.customClass ? data.customClass : '']" #autocomplete>
    <div class="tags-input-container">
      <div class="adc-d-flex adc-align-items-center adc-flex-wrap">
        <span class="adc-tag-icon-right adc-d-flex adc-align-items-center" *ngFor="let tag of selectedTags">
          <label title="{{tag}}"> {{ tag }} </label>
          <span class="material-symbols-outlined remove-tag" (click)="removeTag(tag)">close</span>
        </span>
      </div>
      <input
        type="text"
        id="searchInput"
        (input)="onInputChange2($event)"
        placeholder="Type to search"
        [(ngModel)]="searchInput2"
        autocomplete="off"
      />
    </div>
    <ul class="adc-list" id="suggestions" *ngIf="showList2 && suggestions.length > 0" (keydown.arrowdown)="onArrowDown($event)" 
      (keydown.arrowup)="onArrowUp($event)"
      (keydown.enter)="onEnter($event)"
      (keydown.escape)="onEscape($event)">
      <li class="adc-list-item adc-p10" *ngFor="let suggestion of suggestions" (click)="onSuggestionClick2(suggestion)">
        {{ suggestion }}
      </li>
    </ul>
  </div> -->
  <div class="adc-aucmpt" [ngClass]="[inputStyle ? inputStyle : '', data?.customClass ? data.customClass : '']" #autocomplete>
    <div class="tags-input-container" (click)="focusInput()" appClickOutside (clickOutside)="showList2 = false;">
      <div class="adc-d-flex adc-align-items-center adc-flex-wrap">
        <span class="adc-tag-icon-right adc-d-flex adc-align-items-center" *ngFor="let tag of selectedTags">
          <label title="{{tag}}">{{ tag }}</label>
          <span class="material-symbols-outlined remove-tag" (click)="removeTag(tag)">close</span>
        </span>
      </div>
      <input
        type="text"
        id="searchInput"
        (input)="onInputChange2($event)"
        (keydown)="onKeydown($event)" 
        placeholder="Type to search"
        [(ngModel)]="searchInput2"
        autocomplete="off"
        #searchInput
      />
    </div>
    <ul class="adc-list" id="suggestions" *ngIf="showList2 && suggestions.length > 0">
      <li class="adc-list-item adc-p10" *ngFor="let suggestion of suggestions; let i = index" 
          [class.selected]="i === selectedIndex"
          (click)="onSuggestionClick2(suggestion)">
        {{ suggestion }}
      </li>
    </ul>
  </div>
  
</ng-container>


